import './styles/styles.css';
import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect
} from "react-router-dom";
import Navbar from './Components/Navbar/Navbar';
import Home from './Components/Home/Home';
import Resource from './Components/Resource/Resource';
import About from './Components/Home/About/About';
import Guides from './Components/Home/Guides/Guides';
import Precautions from './Components/GuidePages/Precautions/Precautions';
import Symptoms from './Components/GuidePages/Symptoms/Symptoms';
import HomeRemedies from './Components/GuidePages/HomeRemedies/HomeRemedies';
import DonatePlasma from './Components/GuidePages/DonatePlasma/DonatePlasma';
import GetVaccinated from './Components/GuidePages/GetVaccinated/GetVaccinated';
import HelpOnTwitter from './Components/GuidePages/HelpOnTwitter/HelpOnTwitter';
import FirstAid from './Components/GuidePages/FirstAid/FirstAid';
import HowItSpreads from './Components/GuidePages/HowItSpreads/HowItSpreads';
import LinksSection from './Components/Home/LinksSection/LinksSection';
import MentalHealthPage from './Components/Home/MentalHealth/MentalHealthPage';
import MentalHealthButton from './Components/Home/MentalHealth/MentalHealthButton';
import Ambulance from './Components/Ambulance/Ambulance';
import Login from './Components/Login/Login';
import Dashboard from './Components/Dashboard/Dashboard';
import { useStateValue } from './StateProvider';
import axios from './axios'
import Footer from './Components/Footer/Footer';
import Message from './Components/Home/Message/Message';


export default function App() {


  const [fetchData,setFetchData]=useState([]);
  const [fetchRequests,setFetchRequests]=useState([]);

  const [{loggedIn,currentPage}, dispatch] = useStateValue()

  useEffect(() => {
    dispatch({
        type: 'UPDATE_ALL_RESOURCE_DATA',
        data: fetchData,
        requests: fetchRequests
    })
  }, [fetchData,fetchRequests])

  const getResourceData= async () => {
    const response = await axios.get(`/viewResources/all`)

    setFetchData(response.data)
}

const getRequestData= async () => {
  const response = await axios.get(`/updateRequests/getRequests`)

  setFetchRequests(response.data)
}

useEffect(() => {
    getResourceData()
    getRequestData()
}, [])

  return (
    <div className='App'>
      <Router>
        
        <Navbar notHomePage/>
        
        <Switch>

          <Route path="/login">
            {
              (loggedIn && currentPage === 'home') ? (<Redirect to='/dashboard' />)  : (loggedIn && currentPage !== 'home') ? (<Redirect to={'/'.concat(currentPage)} />) : (<Login/>)
            }
          </Route>
          <Route path="/dashboard">
            <Dashboard/>
          </Route>
          
          <Route path="/Plasma">
            <Resource type="Plasma"/>
          </Route>
          <Route path="/Oxygen">
            <Resource type="Oxygen" nationWideSupplier={'https://drive.google.com/file/d/1rF-g-KQ0hBht-PJCgGdpEnQfZdb3CU84/view'}/>
          </Route>
          <Route path="/Beds">
            <Resource type="Beds"/>
          </Route>
          <Route path="/Remdesivir">
            <Resource type="Remdesivir" nationWideSupplier={'https://vaccineindia.org/new/admin-master/public/ckeditor/kcfinder/upload/files/Remdesivir-Distributor-List.pdf'}/>
          </Route>
          <Route path="/Food">
            <Resource type="Food"/>
          </Route>
          <Route path="/ambulance-help">
            <Ambulance/>
          </Route>


          <Route path="/precautions">
            <Precautions />
          </Route>
          <Route path="/symptoms">
            <Symptoms />
          </Route>
          <Route path="/homeRemedies">
            <HomeRemedies />
          </Route>
          <Route path="/getVaccinated">
            <GetVaccinated />
          </Route>
          <Route path="/donate-plasma">
            <DonatePlasma />
          </Route>
          <Route path="/allAboutMasks">
            <HelpOnTwitter />
          </Route>
          <Route path="/first-aid-at-home">
            <FirstAid />
          </Route>
          <Route path="/how-it-spreads">
            <HowItSpreads />
          </Route>

          <Route path="/mental-health-page">
            <MentalHealthPage/>
          </Route>

          <Route path="/">
            <Navbar HomePage/>
            <Home/>
            <About/>
            <Guides/>
            <MentalHealthButton/>
            <LinksSection/>
            <Message/>
          </Route>
          
        </Switch>

        <Footer/>
      </Router>
    </div>
  );
}